<template>
  <v-col cols="12" class="pt-0 mt-0">
    <v-list class="py-0 my-0" density="compact">
      <v-list-subheader>
        <span style="line-height: 36px">Адреса:</span>
        <v-btn icon flat size="x-small" v-show="edit" @click="$emit('add')">
          <v-icon color="primary">add</v-icon>
        </v-btn>
      </v-list-subheader>
      <v-list-item
        v-for="(item, i) in addresses"
        :key="i"
        active-color="primary"
      >
        <template v-slot:prepend>
          <v-icon color="primary">home</v-icon>
        </template>
        <template v-slot:append>
          <v-btn icon flat size="x-small" v-show="edit" @click="$emit('edit', item)">
            <v-icon color="primary">edit</v-icon>
          </v-btn>
          <v-btn icon flat size="x-small" v-show="edit" @click="$emit('delete', item)">
            <v-icon color="primary">delete</v-icon>
          </v-btn>
        </template>
        <v-list-item-title class="text-wrap">
          <span>{{ item.free }}</span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="addresses && addresses.length === 0">
        <template v-slot:prepend>
          <v-icon color="primary">home</v-icon>
        </template>
        <v-list-item-title>
          <span>не указан</span>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-col>
</template>

<script>
export default {
  name: 'AddressesSection',
  props: {
    addresses: {
      type: Array,
      default: () => []
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  emits: ['add', 'edit', 'delete'],
}
</script>
